import { render, staticRenderFns } from "./ip-data-center.vue?vue&type=template&id=d0b58b90&"
import script from "./ip-data-center.vue?vue&type=script&lang=ts&"
export * from "./ip-data-center.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports